import React, { FC, memo, useContext } from 'react';
import { SitecoreContextReactContext, Text } from '@sitecore-jss/sitecore-jss-react';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import { fields } from '../../../../constants/fields.const';
import { iconSize } from '../../../../constants/icon.constants';
import useEEActive from '../../../../hooks/useEEActive';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import { TLinkField } from '../../../../types/sitecore.types';
import { FieldEditFrameComponent } from '../../../@shared/editFrame';
import Icon from '../../../@shared/icon';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import { TFloatingMenuLinkProps } from '../../types/productFloatingMenu.types';
import './styles.scss';

const WrapComponent: FC<{ wrapper: 'link' | 'div'; link?: TLinkField; wrapperClassName?: string, children?: JSX.Element | JSX.Element[] }> = ({
  wrapper,
  children,
  link = {},
  wrapperClassName = undefined,
}) => {
  if (wrapper === 'div') return <div className={wrapperClassName}>{children}</div>;
  return (
    <RoutableSitecoreLink field={link} className={wrapperClassName}>
      {children}
    </RoutableSitecoreLink>
  );
};

const FloatingMenuLink: FC<TFloatingMenuLinkProps> = (props) => {
  const isWide = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-p']})`);
  const { link, icon, title = {}, itemId = '', handleLinkClick, extraClassName = '' } = props;
  const isEEactive = useEEActive();
  const sitecoreContextFactory = useContext(SitecoreContextReactContext);
  const sitecoreContext = sitecoreContextFactory.context;
  const iconWideSize = isWide ? iconSize.dsk : iconSize.mbl;

  const desktopFloatingLink = (
    <li className={`floating-links-link ${extraClassName}`} onClick={handleLinkClick}>
      <WrapComponent wrapper={isEEactive || !link ? 'div' : 'link'} link={link}>
        <div className="floating-links-link__link">
          <Text field={title} tag="p" />
        </div>
        <div className="floating-links-link__image-wrapper">
          <div className="floating-links-link__image">
            <FieldEditFrameComponent itemId={itemId} fields={[fields.icon, fields.isMobile, fields.link]} sitecoreContext={sitecoreContext}>
              <Icon iconField={icon} color={'white'} size={iconWideSize} />
            </FieldEditFrameComponent>
          </div>
          <div className="floating-links-link__line"></div>
        </div>
      </WrapComponent>
    </li>
  );

  const mobileFloatingLink = (
    <li className={`floating-links-link ${extraClassName}`} onClick={handleLinkClick}>
      <WrapComponent wrapper={isEEactive || !link ? 'div' : 'link'} link={link} wrapperClassName="floating-links-link__link">
        <div className="floating-links-link__image-wrapper">
          <div className="floating-links-link__image">
            <FieldEditFrameComponent itemId={itemId} fields={[fields.icon, fields.isMobile, fields.link]} sitecoreContext={sitecoreContext}>
              <Icon iconField={icon} color={'white'} size={iconSize.mbl} />
            </FieldEditFrameComponent>
          </div>
        </div>
        <Text field={title} tag="p" />
      </WrapComponent>
    </li>
  );

  return isWide ? desktopFloatingLink : mobileFloatingLink;
};

export default memo(FloatingMenuLink);
